import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { PropTypes } from 'prop-types';
import C from 'classnames';
import DropdownSectionIcon from '../icons/dropdownSectionIcon';

const DropdownSection = ({ title, children }) => {
  const [show, setShow] = useState(true);

  return (
    <div className="dropdown-section">
      <Card className="card-border dropdown-section__head">
        <CardBody>
          <button
            className="dropdown-section__head-button"
            onClick={() => setShow(!show)}
          >
            <div className="dropdown-section__title">{title}</div>
            <div
              className={C('dropdown-section__head-button-icon', {
                'dropdown-section__head-button--expanded': show,
              })}
            >
              <DropdownSectionIcon />
            </div>
          </button>
        </CardBody>
      </Card>
      <Card
        className={`card-border dropdown-section__body ${
          !show ? 'dropdown-section__body--hide' : ''
        }`}
      >
        <CardBody>
          <div>{children}</div>
        </CardBody>
      </Card>
    </div>
  );
};

DropdownSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default DropdownSection;
